import { Theme } from "@mui/material/styles";

const useStylesCard = (theme: Theme, editMode = false) => ({
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "100%",
    minWidth: "200px",
    maxWidth: "520px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    gap: 0.5,
    padding: 2,
    position: "relative",
    borderRadius: "8px",
    boxShadow:
      "0px 1px 2px 0px rgba(0, 0, 0, 0.06), 0px 4px 10px 0px rgba(0, 0, 0, 0.08)",
    borderLeft: `8px solid ${theme.palette.primary.main}`,
    backgroundColor: "background.card",
    transition: "box-shadow 0.2s ease, transform 0.2s ease",
    "&:hover": {
      boxShadow:
        "0px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 8px 20px 0px rgba(0, 0, 0, 0.12)",
      transform: "translateY(-2px)",
    },
  },
  deleteCardAction: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "180px",
    position: "absolute",
    zIndex: 1,
    right: 0,
    top: 0,
  },

  deleteIcon: { fontSize: "60px" },

  title: {
    color: "text.primary",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "100%",
    letterSpacing: "0.25px",
    textWrap: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "100%",
  },
  subtitle: {
    display: "flex",
    padding: "4px",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "background.textField",
    borderRadius: "5px",
    color: "text.secondary",
    fontFamily: "Roboto",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "12px",
    letterSpacing: "0.15px",
    gap: "10px",
  },
  containerChip: {
    display: "flex",
    flexWrap: "nowrap",
    width: "100%",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "row",
    gap: 0.5,
  },
  containerItens: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    gap: "8px",
  },
  containerDate: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
    gap: 1.5,
  },
  containerTitles: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  itens: {
    color: "text.primary",
    fontFamily: "Roboto",
    fontSize: "14px",
    fontStyle: "normal",
    lineHeight: "16px",
    letterSpacing: "0.15px",
    textWrap: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "100%",
  },
  dateTitle: {
    color: "text.secondary",
    fontFamily: "Roboto",
    paddingTop: "8px",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "13px",
    letterSpacing: "0.15px",
  },
  date: {
    paddingTop: "4px",
    color: "text.primary",
    fontFamily: "Roboto",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "14px",
    letterSpacing: "0.15px",
  },
  boxButtonModalDate: {
    width: "100%",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "end",
  },
  buttonModalDate: { marginX: 2, mt: -3, mb: 2 },
  iconButton: {
    position: "absolute",
    top: 8,
    right: 8,
    zIndex: 2,
  },
});

export default useStylesCard;
